import { MarkBand } from "./MarkingScaleEditor";

export interface ScalePreset {
  id: string;
  name: string;
  bands: MarkBand[];
}

export const PRESETS: ScalePreset[] = [
  {
    id: "aus_hd",
    name: "Australian HD/D/C/P/F (85/75/65/50)",
    bands: [
      { label: "HD", min: 85, colour: "#38bdf8" },
      { label: "D", min: 75, colour: "#60a5fa" },
      { label: "C", min: 65, colour: "#818cf8" },
      { label: "P", min: 50, colour: "#facc15" },
      { label: "F", min: 0, colour: "#f87171" },
    ],
  },
  {
    id: "us_letter",
    name: "US A/B/C/D/F (90/80/70/60)",
    bands: [
      { label: "A", min: 90, colour: "#38bdf8" },
      { label: "B", min: 80, colour: "#60a5fa" },
      { label: "C", min: 70, colour: "#818cf8" },
      { label: "D", min: 60, colour: "#facc15" },
      { label: "F", min: 0, colour: "#f87171" },
    ],
  },
  {
    id: "uk_honours",
    name: "UK 1st/2:1/2:2/3rd/Fail (70/60/50/40)",
    bands: [
      { label: "1st", min: 70, colour: "#38bdf8" },
      { label: "2:1", min: 60, colour: "#60a5fa" },
      { label: "2:2", min: 50, colour: "#818cf8" },
      { label: "3rd", min: 40, colour: "#facc15" },
      { label: "Fail", min: 0, colour: "#f87171" },
    ],
  },
];
